module.exports = __webpack_public_path__ + "img/buck-mob-ghost-logo.8c770de3.svg";